import React from 'react';
import { companyValues } from '../../data/aboutPage';

// "Our Values" — a calm, centred list on black with an outlined arrow leading each value.
export function ValuesList() {
  const last = companyValues.length - 1;
  return <section aria-labelledby="values-title" className="w-full bg-ink" data-id="element-68" data-mp="ru5yshrkf4g9">
      <div data-id="element-69" data-mp="mxfk9yvesgwy">
        <div className="mx-auto max-w-3xl px-6 py-16 md:px-8 md:py-24" data-id="element-70" data-mp="mvme0kopjyph">
          <h2 id="values-title" className="text-center type-h2 text-white" data-id="element-71" data-mp="ivkjqwlay7k8">
            Our Values
          </h2>
          <ul className="mt-12 divide-y divide-white/10 md:mt-16" data-id="element-72" data-mp="e42gg1vt3uw3">
            {companyValues.map((value, index) => <li key={value.title} className="grid grid-cols-[56px_1fr_56px] items-center gap-5 py-7 md:grid-cols-[100px_1fr_100px] md:gap-10" data-id="element-73" data-mp="960xdgydrvkm" data-mpi={index}>
                <OutlineArrow data-id="element-74" data-mp="3vcg0nvlae14u" />
                <div className="text-center" data-id="element-75" data-mp="3vcpkt2jnhe2m">
                  {index === last ? <p className="mb-3 type-small italic text-white/60" data-id="element-76" data-mp="3raugdp6fakkm">And finally…</p> : null}
                  <h3 className="type-h5 uppercase text-white" data-id="element-77" data-mp="3rd8ds4oks8vc">{value.title}</h3>
                  <p className="mt-2 type-card-desc text-white/80" data-id="element-78" data-mp="2fx437d545mt5">{value.text}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}

// Hollow block arrow drawn as a single white outline, matching the brand artwork.
function OutlineArrow() {
  return <svg viewBox="0 0 100 64" className="h-auto w-14 text-white md:w-[100px]" fill="none" aria-hidden="true" data-id="element-79" data-mp="2axrf6p2ia9oz">
      <path d="M3 22 H64 V4 L96 32 L64 60 V42 H3 Z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" data-id="element-80" data-mp="33orptivcebpm" />
    </svg>;
}